<template>
    <div class="detail-top-info">
       <ul>
           <li>
               <h5>Musei & gallerie</h5>
           </li>
           <li>
               <div class="before-icon-market">
                   <p><b>100 5th ave</b>, new york city, NY</p>
                   <a href="javascript:void(0)">trova sulla mappa</a>
               </div>
           </li>
           <li>
               <div class="before-icon-clock">
                   <p>Orario di oggi <b>10:00 - 17:30</b></p>
                   <a href="javascript:void(0)">vedi tutti gli orari</a>
               </div>
           </li>
           <li>
               <div class="before-icon-timer">
                   <p><b class="text-uppercase font-weight-bold">Durata consigliata 2-3 ore</b></p>
               </div>
           </li>
       </ul>
    </div>
</template>

<script>
export default {
  name: 'TopInfo'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/front/components/widgets/pages/detail/TopInfo.vue